var map = {
	"./account.store.ts": "d77d",
	"./collect.store.ts": "34b5",
	"./collection-translation.store.ts": "b0c7",
	"./collection.store.ts": "f5c7",
	"./diesel-tax.store.ts": "6e54",
	"./discount.store.ts": "8299",
	"./invite.store.ts": "435f",
	"./log.store.ts": "6d03",
	"./option-translation.store.ts": "d3f7",
	"./option.store.ts": "96a6",
	"./order.store.ts": "e5b4",
	"./product-translation.store.ts": "170f",
	"./product.store.ts": "a187",
	"./reseller.store.ts": "2c48",
	"./review.store.ts": "cec3",
	"./role.store.ts": "27f5",
	"./search.store.ts": "b158",
	"./section-translation.store.ts": "d0fc",
	"./section.store.ts": "cb30",
	"./shipping.store.ts": "d82d",
	"./transport-costs.store.ts": "87ef",
	"./user.store.ts": "bef1",
	"./workspace.store.ts": "e3f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "796c";